import React from 'react';

const ProductContext = React.createContext(null);

export default ProductContext;
